import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
//import 'bootstrap/dist/css/bootstrap.min.css'
import "./theme.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { desabilitaConsoleLog } from "./utils/Utils"
import { ClearCacheProvider } from 'react-clear-cache';

// desabilitaConsoleLog()

ReactDOM.render(
  <Router>
    <ClearCacheProvider duration={5000}>
      <App />
    </ClearCacheProvider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
